import React, { FC, useEffect, useState } from "react";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { Button } from "@/components";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Games } from "@/models/database/games/games.model";
import { createToast } from "@/utils/toaster/createToast";
type GameProps = {
  name: string;
  value: string;
  gameCover: string;
};

const ChallengeGamePicker: FC<{
  label: string;
  value: string;
  setFieldValue: any;
  errors: any;
  name: string;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}> = ({ value, label, setFieldValue, errors, name, setStep }): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true);
  const handleChange = (gameName, gameValue) => {
    if (
      games.find((game) => {
        return game.name === gameName;
      })?.isUpcoming
    ) {
      return createToast({
        type: "info",
        message: "This game is currently not supported. Come back later!",
      });
    }
    setFieldValue(name, gameName);
    setFieldValue("gameType", gameValue);
    setStep((s) => s + 1);
  };

  const [games, setGames] = useState<Games[]>([]);

  useEffect(() => {
    const getGames = async () => {
      const games = collectionRef.games;
      const gamesRes = await games.where("isDisplayed", "==", true).get();
      setLoading(false);
      setGames(
        gamesRes.docs
          .map((doc) => {
            return doc.data() as Games;
          })
          .sort((a, b) => {
            if (!a.isUpcoming && b.isUpcoming) {
              return -1;
            }
            return 0;
          })
      );
    };
    getGames();
  }, []);

  return (
    <>
      <div className="game-picker">
        <label>{label}</label>
        <div className="game-picker__cards">
          {games &&
            games.map((game) => {
              return (
                <div key={game.name}>
                  <Button
                    type="submit"
                    variant="clear"
                    customStyles={`game-picker__card
                  ${game.isUpcoming ? "upcoming" : ""} ${
                    value === game.value ? "active" : ""
                  }`}
                  >
                    <div className="image-handler">
                      <img
                        onClick={() => {
                          handleChange(game.name, game.value);
                        }}
                        data-value={game.name}
                        src={game.gameCover}
                        alt=""
                        className=""
                      />
                    </div>
                    <span
                      aria-label="pick game"
                      onClick={() => {
                        handleChange(game.name, game.value);
                      }}
                      data-value={game.name}
                      className="title-handler"
                    >
                      <></>
                    </span>
                    <span
                      aria-label="pick game"
                      onClick={() => {
                        handleChange(game.name, game.value);
                      }}
                      data-value={game.name}
                      className="game-title"
                    >
                      {game.isUpcoming ? "Coming soon" : game.name}
                    </span>
                  </Button>
                </div>
              );
            })}
          {loading && (
            Array.from(Array(8), (_, ind) => {
              return (
                <div key={ind}>
                  <div className="game-picker__card placeholder">
                    <div className="image-handler" />
                  </div>
                </div>
              )
            })
          )}
        </div>
        {errors && errors[name] && (
          <FormErrorMessage
            text={errors[name] as string}
            isVisible={!!errors[name]}
          />
        )}
      </div>
    </>
  );
};

export default ChallengeGamePicker;
